import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { LoginFailure, LoginRequest, LoginSuccess } from './actions';
import { LoginResponse } from '@models/swagger';

export const featureKey = 'login';

export interface State {
  data: LoginResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(LoginFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(LoginRequest, state => ({ ...state, error: null, loading: true })),
    on(LoginSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
